module.exports = __webpack_public_path__ + "img/map_tree.736c4992.png";